import React from 'react';
import Select from '@lib/components/Select/Select';
import { ComponentProps, defaultProps } from '../types';

export default function SingleSelectPreview({ options, t }: ComponentProps) {
  const preparedOptions = options.map(({ values }) => ({
    value: values[0],
    label: values[0],
  }));
  return (
    <Select
      {...defaultProps}
      options={preparedOptions}
      label={t('choose-option')}
    />
  );
}
